import { MessageComponent } from './message.component';

export default angular
  .module('sfMobile.components.message', [])
  .component('sfMessage', MessageComponent).name;
